// Table Tech Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDtJFYPGSLoG7kn0mqAoNUDKYfppXklZn0",
  authDomain: "table-tech-9ca4a.firebaseapp.com",
  databaseURL: "https://table-tech-9ca4a-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "table-tech-9ca4a",
  storageBucket: "table-tech-9ca4a.firebasestorage.app",
  messagingSenderId: "386534368588",
  appId: "1:386534368588:web:3173c175e5e5f9159c9be9",
  measurementId: "G-DCQT37YPWZ"
}

export default firebaseConfig